"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRedux = require("react-redux");
var _session = require("@mulesoft/exchange-ui-portals-store/lib/domains/session");
var _AssetIcon = _interopRequireDefault(require("../AssetIcon"));
var _Description = _interopRequireDefault(require("../Description"));
var _AssetTitle = _interopRequireDefault(require("../AssetTitle"));
var _AssetOrganization = _interopRequireDefault(require("../AssetOrganization"));
var _AssetContactInfo = _interopRequireDefault(require("../AssetContactInfo"));
var _AssetModifiedDate = _interopRequireDefault(require("../AssetModifiedDate"));
var _Metrics = _interopRequireDefault(require("../Metrics"));
var styles = {
  "container": "VersionAgnosticInformation__container__3mmkC",
  "version-agnostic": "VersionAgnosticInformation__version-agnostic__kd6zO",
  "versionAgnostic": "VersionAgnosticInformation__version-agnostic__kd6zO",
  "is-editing": "VersionAgnosticInformation__is-editing__18KdP",
  "isEditing": "VersionAgnosticInformation__is-editing__18KdP",
  "detail": "VersionAgnosticInformation__detail__2BYwF",
  "metadata": "VersionAgnosticInformation__metadata__15bEb"
}; 
require('./VersionAgnosticInformation.css');
var VersionAgnosticInformation = function VersionAgnosticInformation(_ref) {
  var _assetTypesConfigurat;
  var isExpanded = _ref.isExpanded,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    isEditing = _ref.isEditing,
    _ref$onEditField = _ref.onEditField,
    onEditField = _ref$onEditField === void 0 ? function () {} : _ref$onEditField,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon,
    _ref$isCertified = _ref.isCertified,
    isCertified = _ref$isCertified === void 0 ? false : _ref$isCertified,
    minorVersionModifiedAt = _ref.minorVersionModifiedAt,
    name = _ref.name,
    _ref$contactName = _ref.contactName,
    contactName = _ref$contactName === void 0 ? null : _ref$contactName,
    _ref$contactEmail = _ref.contactEmail,
    contactEmail = _ref$contactEmail === void 0 ? null : _ref$contactEmail,
    organization = _ref.organization,
    type = _ref.type;
  var isAssetAdmin = (0, _exchangeReactHooks.useIsAssetAdmin)();
  var assetTypesConfiguration = (0, _exchangeReactHooks.useAssetTypesConfiguration)();
  var showMetrics = isAssetAdmin && !!((_assetTypesConfigurat = assetTypesConfiguration[type]) !== null && _assetTypesConfigurat !== void 0 && _assetTypesConfigurat.metrics);
  var isMetricsEnabled = (0, _reactRedux.useSelector)(_session.selectors.isMetricsEnabled);
  var getMetadata = function getMetadata() {
    var metadata = [/*#__PURE__*/_react.default.createElement(_exchangeUiComponents.AssetType, {
      type: type
    }), /*#__PURE__*/_react.default.createElement(_AssetOrganization.default, {
      organizationName: organization
    })].concat((0, _toConsumableArray2.default)(contactName || contactEmail || isEditing ? [/*#__PURE__*/_react.default.createElement(_AssetContactInfo.default, {
      isDisabled: isDisabled,
      isEditing: isEditing,
      onEditContactName: function onEditContactName(_ref2) {
        var value = _ref2.value;
        return onEditField({
          fieldName: 'contactName',
          value: value
        });
      },
      onEditContactEmail: function onEditContactEmail(_ref3) {
        var value = _ref3.value,
          isValid = _ref3.isValid;
        return onEditField({
          fieldName: 'contactEmail',
          value: value,
          isValid: isValid
        });
      },
      contactName: contactName,
      contactEmail: contactEmail
    })] : []), [/*#__PURE__*/_react.default.createElement(_AssetModifiedDate.default, {
      minorVersionModifiedAt: minorVersionModifiedAt
    })]);
    if (isMetricsEnabled && showMetrics) {
      metadata.push(/*#__PURE__*/_react.default.createElement(_Metrics.default, null));
    }
    return metadata;
  };
  var renderMetadata = function renderMetadata() {
    if (!isExpanded) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: styles.metadata,
      "data-test-id": "version-agnostic-information-metadata"
    }, getMetadata().map(function (element, index) {
      return {
        element: element,
        id: "".concat(index, "-information-metadata")
      };
    }).map(function (_ref4) {
      var element = _ref4.element,
        id = _ref4.id;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: id
      }, element);
    }));
  };
  return /*#__PURE__*/_react.default.createElement("article", {
    className: styles.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "version-agnostic-information",
    className: (0, _classnames.default)(styles.versionAgnostic, (0, _defineProperty2.default)({}, styles.isEditing, isEditing))
  }, /*#__PURE__*/_react.default.createElement(_AssetIcon.default, {
    type: type,
    size: isExpanded ? 'md' : 'sm',
    icon: icon,
    alt: name,
    isEditing: isEditing && !isDisabled,
    onEditIcon: function onEditIcon(value, mimeType) {
      return onEditField({
        fieldName: 'icon',
        value: value
      }, {
        type: mimeType
      });
    },
    isCertified: isCertified
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.detail
  }, /*#__PURE__*/_react.default.createElement(_AssetTitle.default, {
    isDisabled: isDisabled,
    assetName: name,
    isEditing: isEditing,
    onEditName: function onEditName(value) {
      return onEditField({
        fieldName: 'name',
        value: value
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_Description.default, {
    isDisabled: isDisabled,
    description: description,
    isEditing: isEditing,
    onEditDescription: function onEditDescription(value) {
      return onEditField({
        fieldName: 'description',
        value: value
      });
    }
  }), renderMetadata())));
};
var _default = exports.default = VersionAgnosticInformation;
//# sourceMappingURL=VersionAgnosticInformation.js.map